// employeeSampleData.js
export const employeeCSVHeaders = [
  { label: "emp_id", key: "emp_id" },
  { label: "first_name", key: "first_name" },
  { label: "last_name", key: "last_name" },
  { label: "email", key: "email" },
  { label: "password", key: "password" },
  { label: "dob", key: "dob" },
  { label: "joining_date", key: "joining_date" },
  { label: "country_code", key: "country_code" },
  { label: "contact_number", key: "contact_number" },
  { label: "gender", key: "gender" },
  { label: "branch", key: "branch" },
  { label: "primary_department", key: "primary_department" },
  { label: "reporting_manager", key: "reporting_manager" },
  { label: "role", key: "role" },
  { label: "work_schedule", key: "work_schedule" },
  { label: "profile_timezone", key: "profile_timezone" },
  { label: "is_active", key: "is_active" },
  {
    label: "allow_check_in/out_outside_the_range",
    key: "allow_check_in/out_outside_the_range",
  },
  {
    label: "outside_range_notes_required",
    key: "outside_range_notes_required",
  },
  { label: "allow_web_check_in/out", key: "allow_web_check_in/out" },
];

export const employeeSampleData = [
  {
    emp_id: "EMP0001",
    first_name: "David",
    last_name: "Davis",
    email: "davis@example.com",
    password: "davis@123",
    dob: "1990-01-31",
    joining_date: "2024-01-02",
    country_code: "+91",
    contact_number: "9876500001",
    gender: "Male",
    branch: "Lintcloud Tech",
    primary_department: "HR",
    reporting_manager: "fayas@lintcloud.com",
    role: "Intern",
    work_schedule: "Morning Shift",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    "allow_check_in/out_outside_the_range": true,
    outside_range_notes_required: true,
    "allow_web_check_in/out": true,
  },
  {
    emp_id: "EMP0002",
    first_name: "Michael",
    last_name: "Wilson",
    email: "wilson@example.com",
    password: "wilson@123",
    dob: "1990-03-02",
    joining_date: "2024-01-03",
    country_code: "+91",
    contact_number: "9876500002",
    gender: "Male",
    branch: "Lintcloud Tech",
    primary_department: "HR",
    reporting_manager: "davis@example.com",
    role: "Intern",
    work_schedule: "Morning Shift",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    "allow_check_in/out_outside_the_range": true,
    outside_range_notes_required: true,
    "allow_web_check_in/out": true,
  },
  {
    emp_id: "EMP0003",
    first_name: "Michael",
    last_name: "Thomas",
    email: "thomas@example.com",
    password: "thomas@123",
    dob: "1990-04-01",
    joining_date: "2024-01-04",
    country_code: "+91",
    contact_number: "9876500003",
    gender: "Male",
    branch: "Lintcloud Tech",
    primary_department: "HR",
    reporting_manager: "davis@example.com",
    role: "Intern",
    work_schedule: "Morning Shift",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    "allow_check_in/out_outside_the_range": true,
    outside_range_notes_required: true,
    "allow_web_check_in/out": true,
  },
  {
    emp_id: "EMP0004",
    first_name: "Jane",
    last_name: "Brown",
    email: "jane@example.com",
    password: "jane@123",
    dob: "1990-05-01",
    joining_date: "2024-01-05",
    country_code: "+91",
    contact_number: "9876500004",
    gender: "Female",
    branch: "Lintcloud Tech",
    primary_department: "HR",
    reporting_manager: "thomas@example.com",
    role: "Intern",
    work_schedule: "Morning Shift",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    "allow_check_in/out_outside_the_range": true,
    outside_range_notes_required: true,
    "allow_web_check_in/out": true,
  },
  {
    emp_id: "EMP0005",
    first_name: "Daniel",
    last_name: "Johnson",
    email: "daniel@example.com",
    password: "daniel@123",
    dob: "1990-05-31",
    joining_date: "2024-01-06",
    country_code: "+91",
    contact_number: "9876500005",
    gender: "Male",
    branch: "Lintcloud Tech",
    primary_department: "HR",
    reporting_manager: "davis@example.com",
    role: "Intern",
    work_schedule: "Morning Shift",
    profile_timezone: "Asia/Kolkata",
    is_active: true,
    "allow_check_in/out_outside_the_range": true,
    outside_range_notes_required: true,
    "allow_web_check_in/out": true,
  },
];
